var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ImageSvg',{attrs:{"src":_vm.logoUrl,"height":28,"alt":`${_vm.state.merchant.name} логотип`,"width":"auto"}})
}
var staticRenderFns = []

export { render, staticRenderFns }